/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */

export enum ECarData {
  NEW_CAR_MIN_PRICE = 'newCarMinPrice',
  LEASE_CAR_MIN_PRICE = 'leaseMinPrice',
}
